<template>
  <!-- 分時車流 -->
  <div class="col">
    <div class="card card-clean h-100">
      <div class="card-header bg-white border-0 fw-bold text-indigo h5">
        分時車流
      </div>
      <div class="card-body p-2">
        <div class="d-flex justify-content-end">
          <button  class="btn btn-dia " style="" @click="showModal()" v-if="!isShortView">
            <i class="fas fa-search-plus"></i>
          </button>
        </div>
        <div style="margin: auto; max-width: 450px; margin-bottom: 30px">
          <apexchart
            v-if="chartSeries"
            type="area"
            :options="chartOptions"
            :series="chartSeries"
          ></apexchart>
        </div>
        <dialog-modal  id="modalPop" ref="objectDetectionDetail" :showUpdateButton="false" :customUpdateButton="false" :modalSize="'xl'"
          :isImage="false" :isMarginAuto="false" :modalTitle="'分時車流'" :closeButton="false" >
          <div class="object-detection-detail w-75 m-auto" >
              <apexchart
                v-if="chartSeries"
                type="area"
                id="chartPop"
                :options="chartOptions"
                :series="chartSeries"
              ></apexchart>
          </div>
        </dialog-modal>
        <div class="chart-description chart-description-btm">
          以分時呈現停車場當日進入的總車流數，08時段為08~09時段的車流。
          <div class="chart-description-sm">
            【註】 車流僅計進入車數，不含離場車數。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import DialogModal from "../../components/DialogModal.vue";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";
import { mapState, mapGetters } from "vuex";
import { postVehicleInTimeIntervalPerHour } from "../../api/eastCoastDataApi/ElkQuery/VehicleElk";
const zh_tw = require("../../utils/apexchartObject/apexLocales/zh-tw.json");

export default {
  components: {
    apexchart: VueApexCharts,DialogModal
  },
  props: ["selectedScenicAreaId"],
  data() {
    return {
      dataInterval: null,
      viewPort: window.innerWidth,
      isShortView:false,
      vehicleData: [],
      chartSeries: [],
      chartOptions: {
        chart: {
          // height: 350,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          defaultLocale: "zh-tw",
          locales: [zh_tw],
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend:{
          onItemClick: {
            toggleDataSeries: false
          }
          
        },
        stroke: {
          curve: "smooth",
          width: 1,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
            // format:'HH',
            datetimeFormatter: {
              day: "MM/dd",
              hour: "HH",
            },
          },
          tooltip: {
            enabled: false,
          },
          categories: [],
        },
        tooltip: {
          x: {
            format: "MM/dd  HH",
            formatter: undefined,
          },
          y: {
            formatter: function (val) {
              return val + "輛";
            },
          },
        },
        colors: CONST.APEXCHART_COLOR.LINE_CHART_RANGE_FIVE,
        markers: {
          size: 0, // 圓點的大小
          //colors: ["#FF0000"], // 圓點的顏色
          //strokeColors: "#fff", // 圓點的邊框顏色
          strokeWidth: 1, // 圓點邊框的寬度
          hover: {
            size: 3, // 滑鼠懸停時圓點的大小
          },
        },
      },
    };
  },
  methods: {
    showModal(){
      this.$refs.objectDetectionDetail.openModal();
    },
    drawChart() {
      let carTypes = Object.values(CONST.ELK_CAR_TYPE_TO_TOURISM); //['小型車', '大型車', '機車']
      let vm = this;

      let seriesData = Object.keys(CONST.ELK_CAR_TYPE_TO_TOURISM).map(
        (currentCarType, indexCarType) => {
          //取得每個area的數據
          let result = {};
          // console.log("currentCarType",currentCarType);
          // console.log("indexCarType",indexCarType);
          result.name = carTypes[indexCarType];
          result.data = vm.vehicleData.map((current, index) => {
            // let count = current.data[currentCarType];
            // if (!count) count = 0;
            //回傳車流數量負數以0計
            let count = current.data[currentCarType] || 0; 
            count = count < 0 ? 0 : count; 
            return count;
          });
          //如果 result.data 長度不足 24，使用 0 填補剩餘的部分
 
          if (result.data.length < 24) {
            result.data = result.data.concat(
              Array(24 - result.data.length).fill(0)
            );
          }
          // console.log("result", result);

          return result;
        }
      );

      let seriesDataTemp = []; //將資料按觀光署分類為大型車/小型車/機車
      seriesData.forEach((current) => {

        let index = seriesDataTemp.findIndex(
          (item) => item.name == current.name
        );
        // console.log("index", index);
        if (index === -1) {
          seriesDataTemp.push({
           ...current,
           data: [...current.data]
         });

  

        } else {
          // console.log("seriesDataTemp[index]", (seriesDataTemp[index]));
          // console.log("seriesDataTemp[index]-J", JSON.stringify(seriesDataTemp[index]));
          // console.log("seriesDataTemp[index].data", (JSON.stringify(seriesDataTemp[index].data)));
          seriesDataTemp[index].data = seriesDataTemp[index].data.map((currentData, indexData) => {
      return currentData + current.data[indexData];
    });
    
        }
 
      });

      let newOptions = { ...this.chartOptions };

      // newOptions.xaxis.categories = this.vehicleData.map((current) => current.dateTime);
      const startDate = moment().startOf("day"); // 獲取當天的開始時間，即午夜 00:00
      const dataLength = 24;
      const categories = [];

      for (let i = 0; i < dataLength; i++) {
        const hour = moment(startDate).add(i, "hours").format("HH:mm");
        const date = moment(startDate).format("YYYY-MM-DD");
        const category = `${date} ${hour}`;
        categories.push(category);
      }

      newOptions.tooltip.x.formatter = function (val) {
        return `${moment(val).format("MM/DD HH")} - ${moment(val)
          .add(1, "hours")
          .format("HH")} `;
      };
      newOptions.xaxis.categories = categories;

      newOptions.chart.toolbar.export = {
        csv: {
          filename: `${this.selectedScenicAreaName}_分時車流_${moment().format(
            "YYYY年MM月DD日_HH時mm分"
          )}`,
        },
        svg: {
          filename: `${this.selectedScenicAreaName}_分時車流_${moment().format(
            "YYYY年MM月DD日_HH時mm分"
          )}`,
        },
        png: {
          filename: `${this.selectedScenicAreaName}_分時車流_${moment().format(
            "YYYY年MM月DD日_HH時mm分"
          )}`,
        },
      };
      this.chartOptions = newOptions;
      this.chartSeries = seriesDataTemp;
    },
    async GetVehicleInTimeIntervalPerHour() {
      let condition = {
        areas: [this.selectedScenicAreaId],
        // sttime: moment().subtract(23, 'hours'),
        // endtime: moment(),
        //sttime: moment('2023-04-02').subtract(11, 'hours'),
        //endtime: moment('2023-04-02'),

        // sttime: moment("2023-04-04").startOf("day"),
        // endtime: moment("2023-04-04").endOf("day").subtract(10, "hour"), //測試用切割時間
        sttime:  moment().startOf("day").format(),
        endtime: moment().format(), //取得當日最早時間與當下最近小時
        interval: "hour",
      };
      let response = await postVehicleInTimeIntervalPerHour(condition);

      // console.log("response.data",response.data)
      return response.data;
    },
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
    selectedScenicAreaName() {
      return Utils.getSingleScenicAreaNamebyId(this.selectedScenicAreaId);
    },
  },

  watch: {
    vehicleData() {
      this.drawChart();
    },
    async selectedScenicAreaId() {
      this.vehicleData = await this.GetVehicleInTimeIntervalPerHour();
    },

    viewPort:{
      handler(newVal){
        if(newVal < 600){
        this.isShortView = true;
      }else{
        this.isShortView = false;
      }},
      immediate: true
    },

  },
  async mounted() {
    this.$_resizeEventHandler = () => {
      this.viewPort = window.innerWidth;
    };
    window.addEventListener('resize', this.$_resizeEventHandler);

    if (this.vehicleData?.length == 0) {
      this.vehicleData = await this.GetVehicleInTimeIntervalPerHour();
    } else {
      this.drawChart();
    }

    // this.dataInterval = setInterval(async () => {
    //   this.vehicleData = await this.GetVehicleInTimeIntervalPerHour();
    // }, CONST.REFRESH_DAT_TIMER_MIN);
  },
  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval);
    this.dataInterval = null;
  },
};
</script>
